(function () {
  if (typeof theme === 'undefined') {
    theme = {};
  }

  theme.wishlistModal = function () {
    var originalMfpOpen = theme.mfpOpen;

    theme.mfpOpenWishlist = function (popup) {
      var closeBtn =
        '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp" aria-label="close"><i class="icon icon--close"></i></button>';

      if (popup === 'wishlist') {
        if (typeof $.magnificPopup !== 'undefined') {
          $.magnificPopup.open({
            items: {
              src: '.js-wishlist-draw',
            },
            type: 'inline',
            mainClass: 'mfp-medium',
            fixedContentPos: true,
            midClick: true,
            closeMarkup: closeBtn,
            removalDelay: 200,
            callbacks: {
              open: function () {
                fetch(window.Shopify.routes.root + 'cart.js')
                  .then((response) => response.json())
                  .then((cartData) => {
                    theme.swymWishlist.updateCartButtons(cartData);
                  })
                  .catch((error) => {
                    console.error('Error fetching cart data:', error);
                  });

                const event = new CustomEvent('cartOpened');
                document.dispatchEvent(event);
              },
            },
          });
        }
      } else if (popup === 'cart') {
        if (typeof $.magnificPopup !== 'undefined') {
          $.magnificPopup.open({
            items: {
              src: '.js-cart-draw',
            },
            type: 'inline',
            mainClass: 'mfp-medium',
            fixedContentPos: true,
            midClick: true,
            closeMarkup: closeBtn,
            removalDelay: 200,
            callbacks: {
              open: function () {
                const event = new CustomEvent('cartOpened');
                document.dispatchEvent(event);
              },
            },
          });
        }
      } else {
        originalMfpOpen.call(this, popup);
      }
    };
  };

  theme.shopifyAPI = {
    getProductByHandle: async function (handle) {
      try {
        const res = await fetch(window.Shopify.routes.root + `products/${handle}.js`);
        if (!res.ok) {
          throw new Error(`Product not found: ${handle}`);
        }
        const productData = await res.json();
        return productData;
      } catch (error) {
        console.error('Error fetching product:', error);
        return null;
      }
    },

    extractHandleFromUrl: function (url) {
      if (!url) return null;
      const match = url.match(/\/products\/([^\/\?]+)/);
      return match ? match[1] : null;
    },

    getVariantById: function (product, variantId) {
      if (!product || !product.variants) return null;
      return product.variants.find((variant) => variant.id == variantId);
    },

    getProductHandle: function (swymItem) {
      if (swymItem.du) {
        const handle = this.extractHandleFromUrl(swymItem.du);
        if (handle) return handle;
      }
      return null;
    },
  };

  theme.swymWishlist = {
    loadWishlist: function () {
      const container = document.getElementById('swym-wishlist');
      if (!container) return;
      container.classList.add('is-updating');

      if (typeof window._swat === 'undefined') {
        container.innerHTML = '<div class="swym-error">Wishlist service is not available</div>';
        container.classList.remove('is-updating');
        return;
      }

      window._swat.fetchLists({
        callbackFn: function (userLists) {
          if (!userLists || userLists.length === 0) {
            theme.swymWishlist.renderEmptyWishlist();
            container.classList.remove('is-updating');
            return;
          }

          const defaultList = userLists[0];

          if (defaultList && defaultList.lid) {
            theme.swymWishlist.renderWishlistItems(defaultList.listcontents);
            theme.swymWishlist.renderWishlistItemsOnPage(defaultList.listcontents);
          } else {
            theme.swymWishlist.renderEmptyWishlist();
          }
          container.classList.remove('is-updating');
        },
        errorFn: function (error) {
          console.error('Error fetching user lists:', error);
          const container = document.getElementById('swym-wishlist');
          if (container) {
            container.innerHTML = '<div class="swym-error">Failed to load wishlist</div>';
            container.classList.remove('is-updating');
          }
        },
      });
    },

    renderWishlistItems: async function (listContents) {
      const buttons = document.querySelector('.wishlist-buttons');
      const buttonsEmpty = document.querySelector('.wishlist-buttons-empty');
      const container = document.getElementById('swym-wishlist');
      if (!container) return;

      if (!listContents || listContents.length === 0) {
        theme.swymWishlist.renderEmptyWishlist();
        return;
      }

      if (buttons) buttons.classList.remove('hidden');
      if (buttonsEmpty) buttonsEmpty.classList.add('hidden');

      try {
        const productsWithData = await Promise.all(
          listContents.map(async function (item) {
            const handle = theme.shopifyAPI.getProductHandle(item);
            const productData = await theme.shopifyAPI.getProductByHandle(handle);

            if (!handle || !productData) {
              return null;
            }

            const variant = theme.shopifyAPI.getVariantById(productData, item.epi) || productData.variants[0];
            const reviews = await theme.yotpoIntegration.getReviewsStatistics(productData.id);

            return {
              swymItem: item,
              product: productData,
              variant: variant,
              reviews: reviews,
              isSwymData: false,
            };
          }),
        );

        const validProducts = productsWithData.filter((item) => item !== null);

        if (validProducts.length === 0) {
          theme.swymWishlist.renderEmptyWishlist();
          return;
        }

        let html = '<div class="swym-wishlist-items">';

        validProducts.forEach(function (item) {
          const { swymItem, product, variant, reviews, isSwymData } = item;
          const reviewsHTML = theme.yotpoIntegration.generateStarsHTML(reviews);

          let priceHTML, productImage, productTitle, productUrl;

          if (isSwymData) {
            priceHTML = `<div class="swym-item-price"><span class="money">$${
              product.pr ? (product.pr / 100).toFixed(2) : '0.00'
            }</span></div>`;
            productImage = product.iu || '';
            productTitle = product.dt || product.title || 'Product';
            productUrl = product.du || '#';
          } else {
            priceHTML = theme.priceHelpers.generatePriceHTML(variant);
            productImage =
              variant.featured_image || product.featured_image || (product.images && product.images[0]) || '';
            if (typeof productImage === 'object') {
              productImage = productImage.src || productImage.url || '';
            }
            productTitle = product.title;
            productUrl = `/products/${product.handle}`;
          }

          html += `
            <div class="swym-wishlist-item" 
              data-product-id="${product.id || product.empi}" 
              data-variant-id="${variant ? variant.id : swymItem.epi}" 
              data-item-id="${swymItem.id}"
            >
              <a href="${productUrl}" class="js-product-link product-link">
              <div class="swym-item-image">
                <img src="${productImage}" alt="${productTitle}" loading="lazy">
              </div>
              <div class="swym-item-details">
                ${reviewsHTML}
                <span class="swym-item-title">
                  ${productTitle}
                </span>
                ${
                  !isSwymData &&
                  variant &&
                  variant.title !== 'Default Title' &&
                  variant.title.toLowerCase() !== 'nothing'
                    ? `<div class="swym-variant-title">Equipment: ${variant.title}</div>`
                    : ''
                }
                ${priceHTML}
              </div>
              </a>
              <div class="swym-item-actions">
                <button class="swym-remove-item-btn" data-item-id="${swymItem.id}" data-wishlist-id="${swymItem.lid}">
                  Remove
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                    <path d="M3.75 3.25V0.75H8.25V3.25M1.75 4.25V13.25H10.25V4.25M0.75 3.75H11.25M4 6V11M8 6V11" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                ${
                  !isSwymData && product.type === 'Hidden'
                    ? ''
                    : `<button class="swym-add-to-cart-btn c-btn c-btn--hollow add-to-cart-btn ${
                        !isSwymData && variant && !variant.available ? 'disabled' : ''
                      }" 
                        data-variant-id="${variant ? variant.id : swymItem.epi}" 
                        ${!isSwymData && variant && !variant.available ? 'disabled' : ''}>
                  ${!isSwymData && variant && !variant.available ? 'Out of stock' : 'Add to cart'}
                </button>`
                }
              </div>
            </div>
          `;
        });

        html += '</div>';
        container.innerHTML = html;

        theme.swymWishlist.updateWishlistCount(validProducts.length);
      } catch (error) {
        console.error('Error rendering wishlist:', error);
        container.innerHTML = '<div class="swym-error">Failed to load wishlist items</div>';
      }
    },

    renderWishlistItemsOnPage: async function (listContents) {
      try {
        const wishlistContainer = document.querySelector('.js-loaded_wishlist');
        if (wishlistContainer) {
          const skeletonCard = `
            <div class="wishlist-skeleton__card">
              <div class="wishlist-skeleton__image"></div>
              <div class="wishlist-skeleton__content">
                <div class="wishlist-skeleton__title"></div>
                <div class="wishlist-skeleton__price"></div>
                <div class="wishlist-skeleton__button"></div>
              </div>
            </div>
          `;

          const skeletonCount = 4;
          const skeletonHTML = Array(skeletonCount).fill(skeletonCard).join('');

          wishlistContainer.innerHTML = skeletonHTML;
        }

        const productsWithData = await Promise.all(
          listContents.map(async function (item) {
            const handle = theme.shopifyAPI.getProductHandle(item);
            const productData = await theme.shopifyAPI.getProductByHandle(handle);

            if (!handle || !productData) {
              return null;
            }

            productData.selected_variant = item.epi;
            productData.wishlist_id = item.lid;
            return productData;
          }),
        );

        const validProducts = productsWithData.filter((item) => item !== null);

        if (validProducts.length === 0) {
          theme.swymWishlist.renderEmptyListPage('.js-loaded_wishlist');
          return;
        }

        const productPromises = validProducts.map(async (item) => {
          try {
            const response = await fetch(
              window.Shopify.routes.root +
                `products/${item.handle}?variant=${item.selected_variant}&section_id=wishlist-product`,
            );
            let html = await response.text();

            html = html.replace(
              `data-item-id="${item.id}"`,
              `data-item-id="${item.id}" data-wishlist-id="${item.wishlist_id}"`,
            );

            return html;
          } catch (error) {
            console.error('Error fetching product:', error);
            return null;
          }
        });

        const productHtmls = await Promise.all(productPromises);
        const validHtmls = productHtmls.filter((html) => html !== null);

        if (wishlistContainer) {
          wishlistContainer.innerHTML = '';

          validHtmls.forEach((html) => {
            wishlistContainer.insertAdjacentHTML('beforeend', html);
          });
        }
      } catch (error) {
        console.error('Error rendering wishlist:', error);
        const container = document.querySelector('.js-loaded_wishlist');
        if (container) {
          container.innerHTML = '<div class="swym-error">Failed to load wishlist items</div>';
        }
      }
    },

    renderEmptyListPage: function (className) {
      const container = document.querySelector(className);
      if (!container) return;

      container.innerHTML = `
        <div class="swym-empty-save-for-later">
          <h3>List is empty</h3>
          <p>Add some products to your list to see them here!</p>
        </div>
      `;
    },

    renderEmptyWishlist: function () {
      const container = document.getElementById('swym-wishlist');
      const buttons = document.querySelector('.wishlist-buttons');
      const buttonsEmpty = document.querySelector('.wishlist-buttons-empty');

      if (!container) return;

      theme.swymWishlist.updateWishlistCount(0);
      if (buttons) buttons.classList.add('hidden');
      if (buttonsEmpty) buttonsEmpty.classList.remove('hidden');

      container.innerHTML = `
        <div class="swym-empty-wishlist">
          <h3>Your wishlist is empty</h3>
          <p>Add some products to your wishlist to see them here!</p>
        </div>
      `;
    },

    addToCart: function (variantId, buttonElement) {
      if (buttonElement) {
        buttonElement.disabled = true;
        buttonElement.innerHTML = 'Adding...';
      }

      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (buttonElement) {
            buttonElement.innerHTML = 'Added';
          }

          $(document.body).trigger('rebuildCart.ajaxCart', [data, 'customType']);
          theme.mfpOpen('cart');
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);

          if (buttonElement) {
            buttonElement.disabled = false;
            buttonElement.innerHTML = 'Add to cart';
            buttonElement.style.backgroundColor = '';
          }
        });
    },

    removeFromWishlist: function (itemId, listId) {
      if (typeof window._swat !== 'undefined') {
        const itemElement = document.querySelector(`[data-item-id="${itemId}"]`);
        if (!itemElement) {
          console.error('Item element not found');
          return;
        }

        const productId = itemElement.getAttribute('data-product-id');
        const variantId = itemElement.getAttribute('data-variant-id');
        const productURL = itemElement.querySelector('.js-product-link').getAttribute('href');

        if (!listId) {
          listId = itemElement.getAttribute('data-wishlist-id');
        }

        const product = {
          epi: variantId,
          empi: productId,
          du: `${window.location.origin}${productURL}`,
          qty: 1,
          note: '',
          cprops: {},
        };

        window._swat.deleteFromList(
          listId,
          product,
          function () {
            theme.swymWishlist.loadWishlist();
          },
          function (error) {
            console.log('Error while deleting the Product', error);
          },
        );
      }
    },

    removeFromSaveForLater: function (itemId, listId) {
      if (typeof window._swat !== 'undefined') {
        const itemElement = document.querySelector(`[data-item-id="${itemId}"]`);
        if (!itemElement) {
          console.error('Item element not found');
          return;
        }

        const productId = itemElement.getAttribute('data-product-id');
        const variantId = itemElement.getAttribute('data-variant-id');
        const productURL = itemElement.querySelector('.js-product-link').getAttribute('href');

        const product = [
          {
            epi: variantId,
            empi: productId,
            du: `${window.location.origin}${productURL}`,
            qty: 1,
            note: '',
            cprops: {},
          },
        ];

        window._swat.SaveForLater.remove(
          listId,
          product,
          function () {
            theme.swymWishlist.fetchSaveForLater();
          },
          function (error) {
            console.log('Error while deleting the Product', error);
          },
        );
      }
    },

    updateWishlistCount: function (count) {
      const countElements = document.querySelector('.wishlist-count');
      if (countElements) {
        countElements.textContent = `${count} ${count > 1 ? 'items' : 'item'}`;
        countElements.style.display = count > 0 ? 'block' : 'none';
      }
    },

    updateCartButtons: function (cartData) {
      if (!cartData || !cartData.items) return;

      const addToCartButtons = document.querySelectorAll('.swym-add-to-cart-btn');

      addToCartButtons.forEach((button) => {
        const variantId = parseInt(button.getAttribute('data-variant-id'));
        if (!variantId) return;

        const isInCart = cartData.items.some((item) => item.variant_id === variantId);

        if (isInCart) {
          button.disabled = true;
          button.innerHTML = 'Added!';
          button.classList.add('is-added');
        } else {
          button.disabled = false;
          button.innerHTML = 'Add to cart';
          button.classList.remove('is-added');
        }
      });
    },

    fetchSaveForLater: function () {
      if (typeof window._swat === 'undefined') {
        console.error('Swym service is not available');
        return;
      }

      window._swat.SaveForLater.fetch(
        window._saveforLaterListId,
        function (saveForLaterData) {
          if (saveForLaterData && saveForLaterData.items) {
            theme.swymWishlist.renderSaveForLaterItems(saveForLaterData.items);
          } else {
            theme.swymWishlist.renderEmptyListPage('.js-loaded_save_for_later');
          }
          theme.swymWishlist.loadWishlist();
        },
        function (error) {
          console.error('Error in SaveForLater:', error);
        },
      );
    },

    renderSaveForLaterItems: async function (saveForLaterData) {
      try {
        if (!saveForLaterData || saveForLaterData.length === 0) {
          theme.swymWishlist.renderEmptyListPage('.js-loaded_save_for_later');
          return;
        }

        const productsWithData = await Promise.all(
          saveForLaterData.map(async function (item) {
            const handle = theme.shopifyAPI.getProductHandle(item);
            const productData = await theme.shopifyAPI.getProductByHandle(handle);
            if (productData) {
              productData.selected_variant = item.epi;
              productData.product_id = item.id;
              productData.save_for_later_id = item.lid;
              return productData;
            } else {
              return null;
            }
          }),
        );

        const validProducts = productsWithData.filter((item) => item !== null);

        if (validProducts.length === 0) {
          theme.swymWishlist.renderEmptyListPage('.js-loaded_save_for_later');
          return;
        }

        const saveForLaterContainer = document.querySelector('.js-loaded_save_for_later');
        if (!saveForLaterContainer) return;

        saveForLaterContainer.innerHTML = '';

        for (const item of validProducts) {
          try {
            const response = await fetch(
              window.Shopify.routes.root +
                `products/${item.handle}?variant=${item.selected_variant}&section_id=wishlist-product`,
            );

            let html = await response.text();

            html = html.replace(
              `data-item-id="${item.id}"`,
              `data-item-id="${item.id}" data-save-for-later-id="${item.product_id}" data-save-for-later-list="${item.save_for_later_id}" data-save-for-later`,
            );

            saveForLaterContainer.insertAdjacentHTML('beforeend', html);
          } catch (error) {
            console.error('Error fetching SaveForLater product:', error);
          }
        }
      } catch (error) {
        console.error('Error rendering SaveForLater:', error);
        const container = document.querySelector('.js-loaded_save_for_later');
        if (container) {
          container.innerHTML = '<div class="swym-error">Failed to load SaveForLater items</div>';
        }
      }
    },

    initializeLogoutListener: function () {
      const logoutLink = document.querySelector('.section__title-desc a[href="/account/logout"]');

      if (logoutLink) {
        logoutLink.addEventListener('click', function (e) {
          e.preventDefault();
          theme.swymWishlist.handleLogout();
          sessionStorage.removeItem('wishlist_popup_opened');
        });
      }
    },

    handleLogout: function () {
      const onSuccess = function (response) {
        console.log('Shopper context disconnected successfully:', response);
      };

      const onError = function (error) {
        console.log('Error disconnecting shopper context:', error);
      };

      window._swat.disconnectShopperContext(onSuccess, onError);
    },

    handleShareButtonClick: function () {
      if (typeof window._swat === 'undefined') {
        console.error('Swym service is not available');
        return;
      }

      window._swat.fetchLists({
        callbackFn: function (userLists) {
          if (!userLists || userLists.length === 0) {
            console.error('No user lists found');
            return;
          }

          const defaultList = userLists[0];
          if (!defaultList || !defaultList.lid) {
            console.error('No valid list ID found');
            return;
          }

          const lid = defaultList.lid;
          const onSuccess1 = (response) => {
            window._swat.generateSharedListURL(
              lid,
              (link, lid) => {
                if (navigator.clipboard && window.isSecureContext) {
                  navigator.clipboard
                    .writeText(link)
                    .then(() => {
                      theme.swymWishlist.showCopyNotification();
                    })
                    .catch((err) => {
                      console.error('Failed to copy link:', err);
                    });
                } else {
                  navigator.clipboard.writeText(link).then(
                    function () {
                      console.log('Async: Copying to clipboard was successful!');
                      theme.swymWishlist.showCopyNotification();
                    },
                    function (err) {
                      console.error('Async: Could not copy text: ', err);
                    },
                  );
                }
              },
              (error) => {
                console.error('Error generating link:', error);
              },
            );
          };

          const onError1 = (error) => {
            console.error('Error in first markListPublic request:', error);
          };

          window._swat.markListPublic(lid, onSuccess1, onError1);
        },
        errorFn: function (error) {
          console.error('Error fetching user lists:', error);
        },
      });
    },

    initializeShareButton: function () {
      const shareButton = document.querySelector('.share-button');
      if (shareButton) {
        shareButton.addEventListener('click', function (e) {
          e.preventDefault();
          theme.swymWishlist.handleShareButtonClick();
        });
      }
    },

    showCopyNotification: function () {
      const notification = document.createElement('div');
      notification.textContent = 'Link copied to clipboard';
      notification.className = 'copy-notification';

      document.body.appendChild(notification);

      setTimeout(() => {
        notification.classList.add('slide-out');
        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
          }
        }, 300);
      }, 3000);
    },

    openPopup: function () {
      sessionStorage.setItem('wishlist_popup_opened', 'true');
      const magnific_config = {
        type: 'inline',
        mainClass: 'mfp-medium',
        fixedContentPos: true,
        closeMarkup:
          '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp" aria-label="close"><i class="icon icon--close"></i></button>',
        removalDelay: 200,
      };
      $.magnificPopup.open({
        items: { src: '.js-wishlist-login' },
        ...magnific_config,
      });
    },

    checkProductInWishlist: function (productId, variantId) {
      if (typeof window._swat === 'undefined') {
        return Promise.resolve(false);
      }

      return new Promise(function (resolve) {
        window._swat.fetchLists({
          callbackFn: function (userLists) {
            if (!userLists || userLists.length === 0) {
              resolve(false);
              return;
            }

            const defaultList = userLists[0];
            if (!defaultList || !defaultList.listcontents || defaultList.listcontents.length === 0) {
              resolve(false);
              return;
            }

            const isInWishlist = defaultList.listcontents.some(function (item) {
              return (
                (item.empi == productId || item.empi == productId.toString()) &&
                (item.epi == variantId || item.epi == variantId.toString())
              );
            });

            resolve(isInWishlist);
          },
          errorFn: function (error) {
            console.error('Error checking wishlist:', error);
            resolve(false);
          },
        });
      });
    },

    updateCollectionButtonsState: function () {
      if (typeof window._swat === 'undefined') {
        return;
      }

      const collectionButtons = document.querySelectorAll('.swym-add-to-wishlist-view-product');
      if (collectionButtons.length === 0) return;

      collectionButtons.forEach(function (button) {
        const productId = button.getAttribute('data-product-id');
        const variantId = button.getAttribute('data-variant-id');

        if (!productId || !variantId) return;

        theme.swymWishlist.checkProductInWishlist(productId, variantId).then(function (isInWishlist) {
          if (isInWishlist) {
            button.classList.add('swym-in-wishlist');
            button.setAttribute('data-swaction', 'removeFromWishlist');
            button.setAttribute('aria-label', 'Remove from wishlist');
          } else {
            button.classList.remove('swym-in-wishlist');
            button.setAttribute('data-swaction', 'addToWishlist');
            button.setAttribute('aria-label', 'Add to wishlist');
          }
        });
      });
    },

    handleCollectionButtonClick: function (button) {
      if (typeof window._swat === 'undefined') {
        console.error('Swym service is not available');
        return;
      }

      const productId = button.getAttribute('data-product-id');
      const variantId = button.getAttribute('data-variant-id');
      const productUrl = button.getAttribute('data-product-url');

      if (!productId || !variantId || !productUrl) {
        console.error('Missing product data');
        return;
      }

      const isInWishlist = button.classList.contains('swym-in-wishlist');
      const action = button.getAttribute('data-swaction');

      if (button.disabled) return;
      button.disabled = true;

      const product = {
        epi: variantId,
        empi: productId,
        du: productUrl,
        qty: 1,
        note: '',
        cprops: {},
      };

      if (action === 'removeFromWishlist' || isInWishlist) {
        window._swat.fetchLists({
          callbackFn: function (userLists) {
            if (!userLists || userLists.length === 0) {
              button.disabled = false;
              return;
            }

            const defaultList = userLists[0];
            if (!defaultList || !defaultList.lid) {
              button.disabled = false;
              return;
            }

            window._swat.deleteFromList(
              defaultList.lid,
              product,
              function () {
                button.classList.remove('swym-in-wishlist');
                button.setAttribute('data-swaction', 'addToWishlist');
                button.setAttribute('aria-label', 'Add to wishlist');
                button.disabled = false;

                theme.swymWishlist.loadWishlist();
              },
              function (error) {
                console.error('Error removing from wishlist:', error);
                button.disabled = false;
              },
            );
          },
          errorFn: function (error) {
            console.error('Error fetching lists:', error);
            button.disabled = false;
          },
        });
      } else {
        window._swat.addToWishlist(
          product,
          function () {
            button.classList.add('swym-in-wishlist');
            button.setAttribute('data-swaction', 'removeFromWishlist');
            button.setAttribute('aria-label', 'Remove from wishlist');
            button.disabled = false;

            theme.swymWishlist.loadWishlist();

            const jsWishlistLogin = document.querySelector('.js-wishlist-login');
            if (jsWishlistLogin && !sessionStorage.getItem('wishlist_popup_opened')) {
              theme.swymWishlist.openPopup();
            }
          },
          function (error) {
            console.error('Error adding to wishlist:', error);
            button.disabled = false;
          },
        );
      }
    },

    initializeCollectionButtons: function (containerSelectorOrElement) {
      if (typeof window._swat === 'undefined') {
        return;
      }

      let container;
      if (typeof containerSelectorOrElement === 'string') {
        container = document.querySelector(containerSelectorOrElement);
      } else if (containerSelectorOrElement instanceof HTMLElement) {
        container = containerSelectorOrElement;
      } else {
        container = document;
      }

      const buttons = container
        ? container.querySelectorAll('.swym-add-to-wishlist-view-product')
        : document.querySelectorAll('.swym-add-to-wishlist-view-product');

      if (buttons.length === 0) return;

      if (container && window._swat.initializeActionButtons) {
        const selector =
          typeof containerSelectorOrElement === 'string'
            ? containerSelectorOrElement
            : container.id
              ? '#' + container.id
              : container.className
                ? '.' + container.className.split(' ')[0]
                : null;
        if (selector) {
          window._swat.initializeActionButtons(selector);
        }
      }

      setTimeout(function () {
        theme.swymWishlist.updateCollectionButtonsState();
      }, 200);
    },
  };

  theme.yotpoIntegration = {
    getReviewsStatistics: async function (productId) {
      try {
        const res = await fetch(
          `https://api.yotpo.com/products/F2MNMTj0CrP63wTeiMZns70weIpB1oOvqL8n2UaB/${productId}/bottomline`,
        );

        const data = await res.json();
        return data?.response?.bottomline;
      } catch (error) {
        console.error('Error fetching Yotpo reviews:', error);
        return null;
      }
    },

    generateStarsHTML: function (reviews) {
      if (!reviews || !reviews.total_reviews) return '';

      const rating = parseFloat(reviews.average_score);
      const ratingInteger = Math.floor(rating);
      const ratingDecimal = rating - ratingInteger;

      return `
      <div class="rating-wrapper">
        <div class="rating" role="img" aria-label="Rating: ${rating}">
          <span 
            aria-hidden="true" 
            class="rating-star"
            style="--rating: ${ratingInteger}; --rating-max: 5; --rating-decimal: ${ratingDecimal};">
          </span>
        </div>
        <div class="swym-review-text-wrapper">
          <span aria-hidden="true">
            ${rating}
          </span>
          <span>(${reviews.total_reviews})</span>
        </div>
      </div>
      `;
    },
  };

  theme.priceHelpers = {
    formatPrice: function (priceInCents) {
      if (!priceInCents) return '$0.00';
      const price = priceInCents / 100;
      return `$${price.toFixed(2)}`;
    },

    generatePriceHTML: function (variant) {
      if (!variant) return '<div class="swym-item-price">Price unavailable</div>';

      const price = variant.price;
      const comparePrice = variant.compare_at_price;

      if (comparePrice && comparePrice > price) {
        return `
          <div class="swym-prices">
            <div class="swym-item-price swym-item-price--sale">
              <span class="money">${this.formatPrice(price)}</span>
            </div>
            <div class="swym-item-price swym-item-price--original">
              <s><span class="money">${this.formatPrice(comparePrice)}</span></s>
            </div>
          </div>
        `;
      } else {
        return `
          <div class="swym-item-price">
            <span class="money">${this.formatPrice(price)}</span>
          </div>
        `;
      }
    },
  };

  theme.wishlistEvents = function () {
    document.addEventListener('touchend', function (e) {
      if (e.target.closest('.js-wishlist-trigger')) {
        theme.mfpOpenWishlist('wishlist');
        e.preventDefault();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-wishlist-trigger')) {
        theme.mfpOpenWishlist('wishlist');
        e.preventDefault();
      }

      if (e.target.closest('.swym-add-to-wishlist-view-product')) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.target.closest('.swym-add-to-wishlist-view-product');
        theme.swymWishlist.handleCollectionButtonClick(button);
      }

      if (e.target.closest('.swym-add-to-cart-btn')) {
        e.preventDefault();
        const button = e.target.closest('.swym-add-to-cart-btn');
        if (button.disabled) return;

        const variantId = button.getAttribute('data-variant-id');
        theme.swymWishlist.addToCart(variantId, button);
      }

      if (e.target.closest('.swym-remove-item-btn')) {
        e.preventDefault();
        const button = e.target.closest('.swym-remove-item-btn');
        const itemId = button.getAttribute('data-item-id');
        let listId = button.getAttribute('data-wishlist-id');
        const saveForLaterContainer = button.closest('[data-save-for-later]');
        if (saveForLaterContainer) {
          listId = saveForLaterContainer.dataset.saveForLaterList;
          theme.swymWishlist.removeFromSaveForLater(itemId, listId);
        } else {
          theme.swymWishlist.removeFromWishlist(itemId, listId);
        }
      }
    });
  };

  function initializeSaveForLater(swat) {
    let onSuccess = function (response) {
      window._saveforLaterListId = response.list.lid;
      theme.swymWishlist.fetchSaveForLater();
    };

    swat.SaveForLater.init(onSuccess, function (error) {});
  }

  function onSwymLoadCallback(swat) {
    theme.swymWishlist.loadWishlist();
    theme.swymWishlist.initializeShareButton();
    theme.swymWishlist.initializeLogoutListener();

    theme.swymWishlist.initializeCollectionButtons();

    const jsWishlistLogin = document.querySelector('.js-wishlist-login');

    let event = 'sw:addedtowishlist';
    let listener = function (e) {
      var data = e.detail.d;
      theme.swymWishlist.loadWishlist();
      theme.swymWishlist.updateCollectionButtonsState();
      if (jsWishlistLogin && !sessionStorage.getItem('wishlist_popup_opened')) {
        theme.swymWishlist.openPopup();
      }
    };

    let saveForLaterEvent = 'sw:addedtosavelater';
    let saveForLaterListener = function (e) {
      var data = e.detail.d;
      theme.swymWishlist.fetchSaveForLater();
    };

    let removedfromwishlist = 'sw:removedfromwishlist';
    let deletedListener = function (e) {
      var data = e.detail.d;
      theme.swymWishlist.loadWishlist();
      theme.swymWishlist.updateCollectionButtonsState();
    };

    swat.evtLayer.addEventListener(event, listener);
    swat.evtLayer.addEventListener(removedfromwishlist, deletedListener);
    swat.evtLayer.addEventListener(saveForLaterEvent, saveForLaterListener);
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(initializeSaveForLater);
  window.SwymCallbacks.push(onSwymLoadCallback);

  document.addEventListener('DOMContentLoaded', function () {
    theme.wishlistModal();
    theme.wishlistEvents();
  });

  document.addEventListener('swym:collections-loaded', function () {
    if (typeof window._swat !== 'undefined' && window._swat.initializeActionButtons) {
      const productGrid = document.querySelector('#product-grid');
      if (productGrid) {
        window._swat.initializeActionButtons('#product-grid');
        theme.swymWishlist.updateCollectionButtonsState();
      }
    }
  });

  document.addEventListener('variant:change', function (e) {
    const quickAddModal = document.querySelector('quick-add-modal[open]');
    if (!quickAddModal) return;

    const wishlistButton = quickAddModal.querySelector('.swym-add-to-wishlist-view-product');
    if (!wishlistButton || !e.detail || !e.detail.variant) return;

    const variantId = e.detail.variant.id;
    wishlistButton.setAttribute('data-variant-id', variantId);

    const productId = wishlistButton.getAttribute('data-product-id');
    if (productId && variantId) {
      theme.swymWishlist.checkProductInWishlist(productId, variantId).then(function (isInWishlist) {
        if (isInWishlist) {
          wishlistButton.classList.add('swym-in-wishlist');
          wishlistButton.setAttribute('data-swaction', 'removeFromWishlist');
        } else {
          wishlistButton.classList.remove('swym-in-wishlist');
          wishlistButton.setAttribute('data-swaction', 'addToWishlist');
        }
      });
    }
  });

  document.addEventListener('product:variant-change', function (e) {
    const quickAddModal = document.querySelector('quick-add-modal[open]');
    if (!quickAddModal) return;

    const wishlistButton = quickAddModal.querySelector('.swym-add-to-wishlist-view-product');
    if (!wishlistButton) return;

    const variantInput = quickAddModal.querySelector('input[name="id"]');
    const variantSelect = quickAddModal.querySelector('select[name="id"]');
    const variantId = variantInput ? variantInput.value : variantSelect ? variantSelect.value : null;

    if (variantId) {
      wishlistButton.setAttribute('data-variant-id', variantId);
      const productId = wishlistButton.getAttribute('data-product-id');
      if (productId) {
        theme.swymWishlist.checkProductInWishlist(productId, variantId).then(function (isInWishlist) {
          if (isInWishlist) {
            wishlistButton.classList.add('swym-in-wishlist');
            wishlistButton.setAttribute('data-swaction', 'removeFromWishlist');
          } else {
            wishlistButton.classList.remove('swym-in-wishlist');
            wishlistButton.setAttribute('data-swaction', 'addToWishlist');
          }
        });
      }
    }
  });
})();
